import React from 'react'
import { MarkdownPage } from '@/shared/components'
import AppFooter from '@/shared/components/AppFooter'

export const TermsOfServicePage: React.FC = () => {
  return (
    <>
      <MarkdownPage fileUrl="docs/terms-of-service.md" />
      <AppFooter />
    </>
  )
}
